<div class="mb-5 flex flex-row items-center" [class.justify-center]="env.PURCHASE_HISTORY_BACK_BUTTON">
    <ion-button
        class="absolute left-0"
        *ngIf="env.PURCHASE_HISTORY_BACK_BUTTON"
        (click)="handleBackClicked()"
        color="secondary"
        fill="clear">
        <ion-icon
            class="mr-1 text-xl dark:filter-yellow"
            src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
        </ion-icon>
    </ion-button>

    <h1 class="page-title mb-0">{{ 'PURCHASE_HISTORY_PAGE_TITLE' | translate }}</h1>
</div>

<ridango-date-period-selector
    [startDate]="startDate$ | async"
    [minStartDate]="minStartDate$ | async"
    [maxStartDate]="maxStartDate$ | async"
    [endDate]="endDate$ | async"
    [minEndDate]="minEndDate$ | async"
    [maxEndDate]="maxEndDate$ | async"
    [automaticEnd]="!env.PURCHASE_CALENDAR_FREE_SELECT"
    [diff]="diff$ | async"
    [dateFormat]="dateFormat"
    [showText]="false"
    [showPrint]="showPrintingOption"
    [useMaterialIcon]="true"
    (startDateSet)="startUpdated($event)"
    (endDateSet)="endUpdated($event)"
    (commitPeriodSelect)="updateList()"
    (print)="downloadPurchaseHistoryPdf()">
</ridango-date-period-selector>

<ng-container *ngIf="{ loading: loading$ | async, tickets: tickets$ | async } as vm">
    <ridango-ui-skeleton-loader
        class="w-full"
        *ngIf="vm.loading && (vm.tickets === null || vm.tickets?.length === 0)"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
        height="6rem"
        count="10">
    </ridango-ui-skeleton-loader>

    <div
        class="purchase-detail-view-area-ticket"
        *ngIf="!vm.loading && (vm.tickets === null || vm.tickets?.length === 0)">
        <p class="purchase-detail-view-area-ticket__title">
            {{ 'NO_ACTIVITY_IN_PERIOD_TITLE' | translate }}
        </p>
        <p class="purchase-detail-view-area-ticket__description">
            {{ 'NO_ACTIVITY_IN_PERIOD_DESCRIPTION' | translate }}
        </p>
    </div>

    <section class="ridango-mat-table margin-top-20">
        <table
            *ngIf="!vm.loading && vm.tickets?.length > 0"
            [dataSource]="vm.tickets"
            [attr.aria-busy]="vm.loading"
            mat-table>
            <ng-container matColumnDef="date">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_DATE' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{ 'PURCHASE_HISTORY_TABLE_HEADER_DATE' | translate }}</span>
                    {{ ticket.timestamp | date: env.PRIMARY_DATE_FORMAT }}
                </td>
            </ng-container>

            <ng-container matColumnDef="purchaseType">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_TYPE' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{ 'PURCHASE_HISTORY_TABLE_HEADER_TYPE' | translate }}</span>

                    <div
                        class="flex-column flex"
                        *ngIf="ticket.card_type !== travelCardType.Email && ticket.related_card_name">
                        {{ ticket.related_card_name }}
                        <span>{{ ticket.card_id }}</span>
                    </div>

                    <div *ngIf="ticket.card_type !== travelCardType.Email && !ticket.related_card_name">
                        {{ ticket.card_id }}
                    </div>

                    <div *ngIf="ticket.card_type === travelCardType.Email">
                        {{ ticket.email }}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="purchaseName">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_NAME' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{ 'PURCHASE_HISTORY_TABLE_HEADER_NAME' | translate }}</span>
                    {{ ticket | translateObjectField: 'name' : translate.currentLang }}
                </td>
            </ng-container>

            <ng-container matColumnDef="purchasePlace">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_PLACE' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{
                        'PURCHASE_HISTORY_TABLE_HEADER_PLACE' | translate
                    }}</span>
                    {{ ticket.buyer_channel | translate }}
                </td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_PRICE' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{
                        'PURCHASE_HISTORY_TABLE_HEADER_PRICE' | translate
                    }}</span>
                    {{ ticket.price | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                </td>
            </ng-container>

            <ng-container matColumnDef="total_sum">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_PRICE' | translate }}</th>
                <td *matCellDef="let ticket" mat-cell>
                    <span class="hide-desktop show-mobile">{{
                        'PURCHASE_HISTORY_TABLE_HEADER_PRICE' | translate
                    }}</span>
                    {{ ticket.total_sum | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
                </td>
            </ng-container>

            <ng-container matColumnDef="receipt">
                <th *matHeaderCellDef mat-header-cell>{{ 'PURCHASE_HISTORY_TABLE_HEADER_RECEIPT' | translate }}</th>
                <td *matCellDef="let ticket; let i = index" mat-cell>
                    <ng-container *ngIf="showProductReceipt(ticket.product_properties)">
                        <button
                            class="btn btn--secondary"
                            *ngIf="ticket.status.trim() !== 'N' && ticket.status.trim() !== 'T' && ticket.jwt_token"
                            [ngClass]="{
                                'pn-dark:bg-contrast-black pn-dark:text-white': i % 2 === 0,
                                'pn-dark:!bg-white': i % 2 !== 0
                            }"
                            (click)="download(ticket, $event.target)"
                            (keydown.enter)="download(ticket, $event.target)"
                            (keydown.space)="download(ticket, $event.target)">
                            {{ 'PURCHASE_HISTORY_DOWNLOAD_PDF' | translate }}
                        </button>

                        <p class="refunded" *ngIf="ticket.status.trim() === 'N' || ticket.status.trim() === 'T'">
                            {{ 'PURCHASE_HISTORY_TICKET_REFUNDED' | translate }}
                        </p>

                        <p
                            class="refunded"
                            *ngIf="!ticket.jwt_token && ticket.status.trim() !== 'N' && ticket.status.trim() !== 'T'">
                            {{ 'PURCHASE_HISTORY_NO_PDF_RECIEPT_AVAILABLE' | translate }}
                        </p>
                    </ng-container>
                </td>
            </ng-container>

            <tr *matHeaderRowDef="purchaseTableColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: purchaseTableColumns" mat-row></tr>
        </table>
    </section>
</ng-container>
